(function($) {
    class W4D_TOC {
        constructor() {
            if (!$('body').hasClass('archive')) {
                return;
            }

            this.initSelectors();
            this.bindEvents();
            this.initializeState();
        }

        initSelectors() {
            this.submenuToggle = '.aside-nav__submenu-toggle';
            this.submenuToggleOpen = 'aside-nav__submenu-toggle--open';
            this.navList = '.aside-nav__list';
            this.navListOpen = 'aside-nav__list--open';
            this.navLink = '.aside-nav__link';
            this.navLinkActive = 'aside-nav__link--active';

            this.asideChevrons = $(this.submenuToggle);
        }

        bindEvents() {
            this.asideChevrons.on('click', (e) => this.toggleSubmenu(e));
        }

        initializeState() {
            const bodyClasses = document.body.className;
            const termMatch = bodyClasses.match(/\bterm-(\S+?)(?=\s|$)/);

            if (!termMatch) return;

            const slug = termMatch[1];
            let $currentLink = null;

            // Check each navigation link
            $(this.navLink).each(function() {
                const href = $(this).attr('href');
                if (!href) return;

                // Extract the last segment between slashes (excluding trailing slash)
                const segments = href.split('/').filter(segment => segment.length > 0);
                const lastSegment = segments[segments.length - 1];

                // Check for exact match
                if (lastSegment === slug) {
                    $currentLink = $(this);
                    return false; // Break out of each loop
                }
            });

            if (!$currentLink || !$currentLink.length) return;

            // Add active class to current link
            $currentLink.addClass(this.navLinkActive);

            // Open parent lists and toggle buttons
            const $parentLists = $currentLink.parents(this.navList);
            $parentLists.addClass(this.navListOpen)
                .prev()
                .find('.aside-nav__submenu-toggle')
                .addClass('aside-nav__submenu-toggle--open');

            // Handle next submenu if it exists
            const $nextSubmenu = $currentLink.next(this.navList);
            if ($nextSubmenu.length) {
                $nextSubmenu.addClass(this.navListOpen);
                $currentLink.find(this.submenuToggle).addClass(this.submenuToggleOpen);
            }
        }

        toggleSubmenu(e) {
            e.preventDefault();
            let $toggle = $(e.target);
            let $submenu = $toggle.parent().next();

            if ($submenu.hasClass(this.navListOpen)) {
                $submenu.find(`.${this.navListOpen}`).removeClass(this.navListOpen);
                $submenu.find(`.${this.submenuToggleOpen}`).removeClass(this.submenuToggleOpen);
            }

            $toggle.toggleClass(this.submenuToggleOpen);
            $submenu.toggleClass(this.navListOpen);
        }
    }

    $(document).ready(() => new W4D_TOC());
})(jQuery);